import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDriverAuth } from '../context/DriverAuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Truck } from 'lucide-react';

import { getApiUrl, isBackendConfigured } from '../config';

const DriverLoginPage = () => {
  const navigate = useNavigate();
  const { login } = useDriverAuth();

  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!isBackendConfigured()) {
      setError('Backend URL is not configured. Set REACT_APP_BACKEND_URL in your environment.');
      setLoading(false);
      return;
    }

    const result = await login({ email: loginEmail, password: loginPassword });
    setLoading(false);

    if (result.success) {
      navigate(result.driver?.agreementSignedAt ? '/driver/dashboard' : '/driver/agreement');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-neutral-950 rounded-full">
              <Truck className="w-8 h-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold">Driver Portal</CardTitle>
          <p className="text-gray-600 mt-2">Log in to accept deliveries and manage payouts</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded">
                {error}
              </div>
            )}
            <div>
              <Label htmlFor="login-email">Email</Label>
              <Input
                id="login-email"
                type="email"
                value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="login-password">Password</Label>
              <Input
                id="login-password"
                type="password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-neutral-950 hover:bg-black"
              size="lg"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>

            <p className="text-center text-sm text-gray-600">
              New driver?{' '}
              <Link to="/driver/signup" className="font-semibold text-neutral-900 underline">
                Sign up (21+ only)
              </Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default DriverLoginPage;
